<div>
    <div class="modal" id="canales_izzitvhdplus" aria-hidden="true">
        <div class="modal__overlay" tabindex="-1" data-micromodal-close>
            <div
                class="modal__container modal__container--channels"
                role="dialog"
                aria-modal="true"
            >
                <button
                    class="modal__close"
                    aria-label="Close modal"
                    data-micromodal-close
                />
                <div class="channel-tabs">
                    <div class="channels-headline addon-tab-controls__holder">
                        <div class="h5 fw-semibold">
                            izzi tv con 200 canales
                        </div>
                        <div class="channel-tab-controls">
                            <a
                                href="#izzitvhdplus_hdchannels"
                                class="channel-tab-control channel-tab-control--active"
                                >Canales HD</a
                            >
                            <a
                                href="#izzitvhdplus_sdchannels"
                                class="channel-tab-control">Canales SD</a
                            >
                        </div>
                    </div>
                    <div class="channel-tab__content-holder">
                        <div
                            id="izzitvhdplus_hdchannels"
                            class="channel-tab-content channel-tab-content--active"
                        >
                            <div class="channels-list">
                                <img
                                    data-src="/assets/img/dummy-img/channels/LasEstrellas.png"
                                    alt="Las Estrellas HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/dePeliculaPlus.png"
                                    alt="De Película Plus"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/UniversalChannel_HD.png"
                                    alt="Universal HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/lasEstrellas-2.png"
                                    alt="Las Estrellas -2 Horas HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/GPlus.png"
                                    alt="Golden Plus"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/HGTV.png"
                                    alt="HGTV HD"
                                />
                                <img
                                    class="m-l-5"
                                    data-src="/assets/img/dummy-img/channels/N_Mas-Foro.png"
                                    alt="N+ Foro"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/ParamountChannelHD.png"
                                    alt="Paramount Channel HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/DisneyChannelHD.png"
                                    alt="Disney Channel HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/5HD.png"
                                    alt="Canal Cinco HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/TNT-HD.png"
                                    alt="TNT HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/tntNovelas.png"
                                    alt="TNT Novelas"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/ComedyCentral_HD.png"
                                    alt="Comedy Central HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/nueveHD.png"
                                    alt="Nueve HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/aMC_HD.png"
                                    alt="AMC HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/FoxNewsChannel.png"
                                    alt="Fox News HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/U.png"
                                    alt="Unicable HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/canal6Plus.png"
                                    alt="Canal 6 Plus"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/studioUniversal.png"
                                    alt="Studio Universal"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/WB_HD.png"
                                    alt="Warner Brothers HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/adultswim_HD.png"
                                    alt="AdultSwim HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/bitMe.png"
                                    alt="bitMe HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/History_HD.png"
                                    alt="History HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/CineCanal.png"
                                    alt="Cinecanal HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/telehit.png"
                                    alt="Telehit HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/Milenio.png"
                                    alt="Milenio"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/VH1.png"
                                    alt="MTV 00S"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/food.png"
                                    alt="Food HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/CNN_HD.png"
                                    alt="CNN en Español HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/A3S.png"
                                    alt="Antena 3 Series HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/star-tve.png"
                                    alt="Star TVE HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/Star-Channel.png"
                                    alt="Star Channel"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/FX.png"
                                    alt="FX HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/S_HD.png"
                                    alt="Sony HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/AXN_HD.png"
                                    alt="AXN HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/Space_HD.png"
                                    alt="Space HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/DiscoveryScience.png"
                                    alt="Discovery Science"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/World HD.png"
                                    alt="Discovery World HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/A&E_HD.png"
                                    alt="A&E HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/ID.png"
                                    alt="Investigation Discovery"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/NatGeoHD.png"
                                    alt="National Geographic HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/h&h_HD.png"
                                    alt="Home & Health HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/HolaTv.png"
                                    alt="Hola TV HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/Mtv_HD.png"
                                    alt="MTV HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/MtvLive_HD.png"
                                    alt="MTV Live HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/teenNick.png"
                                    alt="Teen Nick"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/discoveryKidsHD.png"
                                    alt="Discovery Kids HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/clan.png"
                                    alt="Clan HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/DiscoveryTurbo.png"
                                    alt="Discovery Turbo HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/TheaterHD.png"
                                    alt="Discovery Theater HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/animalPlanet.png"
                                    alt="Animal Planet HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/D_HD.png"
                                    alt="Discovery Channel HD"
                                />
                                <img
                                    class="large-logo"
                                    data-src="/assets/img/dummy-img/channels/RealMadridTv.png"
                                    alt="Real Madrid TV HD"
                                />
                                <img
                                    class="large-logo"
                                    data-src="/assets/img/dummy-img/channels/Adrenalina.png"
                                    alt="Adrenalina HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/TUDN.png"
                                    alt="TUDN HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/FoxSports.png"
                                    alt="Fox Sports"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/FoxSports2.png"
                                    alt="Fox Sports 2"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/FoxSports3.png"
                                    alt="Fox Sports 3"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/ESPN.png"
                                    alt="ESPN HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/ESPN2.png"
                                    alt="ESPN2 HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/ESPN3.png"
                                    alt="ESPN3 HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/ESPN4.png"
                                    alt="ESPN+ HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/nfl-hd.png"
                                    alt="NFL Network HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/A3CINE.png"
                                    alt="Antena 3 Cine HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/dreamworks.png"
                                    alt="Dreamworks"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/sony-movies.png"
                                    alt="Sony Movies"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/curiosity.png"
                                    alt="Curiosity"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/e-e-europa-square.png"
                                    alt="E E Europa"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/film-arts-square.png"
                                    alt="Film & Arts"
                                />
                                <img
                                    class="large-logo"
                                    data-src="/assets/img/dummy-img/channels/PXSports.png"
                                    alt="PX Sports"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/nickelodeon.png"
                                    alt="Nickelodeon"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/usa.png"
                                    alt="usa"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/NBA_TV.png"
                                    alt="NBA TV"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/tlnovelas.png"
                                    alt="TLNovelas"
                                />
                            </div>
                        </div>
                        <div
                            id="izzitvhdplus_sdchannels"
                            class="channel-tab-content"
                        >
                            <div class="channels-list">
                                <img
                                    data-src="/assets/img/dummy-img/channels/LasEstrellas.png"
                                    alt="Las Estrellas"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/cinco.png"
                                    alt="Canal Cinco"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/canalOnce.png"
                                    alt="Canal Once"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/canalCatorce.png"
                                    alt="Canal Catorce"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/22.png"
                                    alt="Canal 22"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/FX.png"
                                    alt="FX"
                                />
                                <img
                                    class="m-r-5"
                                    data-src="/assets/img/dummy-img/channels/N_Mas-Foro.png"
                                    alt="N+ Foro"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/nueve.png"
                                    alt="Nueve"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/home&Health.png"
                                    alt="Discovery Home & Health"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/canal6Plus.png"
                                    alt="Canal 6 Plus"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/tvQuiero.png"
                                    alt="TV Quiero"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/tv-unam.png"
                                    alt="TV Unam"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/canalJudicial.png"
                                    alt="Canal Judicial"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/space.png"
                                    alt="Space"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/imagen-television.png"
                                    alt="Imagen Televisión"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/DistritoComedia.png"
                                    alt="Distrito Comedia"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/Telemundo.png"
                                    alt="Telemundo"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/E.png"
                                    alt="E!"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/canalDelCongreso.png"
                                    alt="Canal del Congreso"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/U.png"
                                    alt="Unicable"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/telehit.png"
                                    alt="Telehit"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/telehitMusica.png"
                                    alt="Telehit Música"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/Bandamax.png"
                                    alt="Bandamax"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/lifeTime.png"
                                    alt="Lifetime"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/studioUniversal.png"
                                    alt="Studio Universal"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/onceNinos.png"
                                    alt="Once Niños"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/CN.png"
                                    alt="Cartoon Network"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/bitMe.png"
                                    alt="bitMe"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/DisneyChannel.png"
                                    alt="Disney Channel"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/DisneyJunior.png"
                                    alt="Disney Junior"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/DiscoveryKids.png"
                                    alt="Discovery Kids"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/Discovery.png"
                                    alt="Discovery Channel"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/NationalGeografic.png"
                                    alt="National Geographic"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/History.png"
                                    alt="History"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/sony-channel.png"
                                    alt="Sony"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/enlace.png"
                                    alt="Enlace"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/EWTN.png"
                                    alt="EWTN"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/Aprende.png"
                                    alt="@prende+"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/22.2.png"
                                    alt="MX Nuestro Cine"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/teleFormula.png"
                                    alt="Telefórmula"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/Milenio.png"
                                    alt="Milenio"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/TUDN.png"
                                    alt="TUDN"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/FoxSports.png"
                                    alt="Fox Sports"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/FoxSports2.png"
                                    alt="Fox Sports 2"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/ESPN.png"
                                    alt="ESPN"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/ESPN2.png"
                                    alt="ESPN2"
                                />
                                <img
                                    class="large-logo"
                                    data-src="/assets/img/dummy-img/channels/RealMadridTv.png"
                                    alt="Real Madrid TV"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/WBtv.png"
                                    alt="Warner Brothers"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/dePelicula.png"
                                    alt="De Película"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/Golden.png"
                                    alt="Golden"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/EDGE.png"
                                    alt="Edge"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/tnt.png"
                                    alt="TNT"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/aMC.png"
                                    alt="AMC"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/CINEMAX.png"
                                    alt="Cinemax"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/Star-Channel.png"
                                    alt="Star Channel"
                                />
                                <img
                                    class="large-logo"
                                    data-src="/assets/img/dummy-img/channels/Adrenalina.png"
                                    alt="Adrenalina"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/AXN.png"
                                    alt="AXN"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/tlc.png"
                                    alt="TLC"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/TCM.png"
                                    alt="TCM"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/G.png"
                                    alt="G"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/lasEstrellas-2.png"
                                    alt="Las Estrellas -2 horas"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/HGTV.png"
                                    alt="HGTV"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/tve.png"
                                    alt="TVE"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/ComedyCentral.png"
                                    alt="Comedy Central"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/food.png"
                                    alt="Food"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/DMX.png"
                                    alt="STINGRAY MUSIC"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/CineCanal.png"
                                    alt="Cinecanal"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/HolaTv.png"
                                    alt="Hola TV"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/TNTseries.png"
                                    alt="TNT Series"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/masChic.png"
                                    alt="Mas Chic"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/adultswim_HD.png"
                                    alt="AdultSwim HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/nickjr.png"
                                    alt="Nick JR"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/Boomerang.png"
                                    alt="Cartoonito"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/nickMusic.png"
                                    alt="Nick Music"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/DiscoveryTurbo.png"
                                    alt="Discovery Turbo"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/ID.png"
                                    alt="Investigation Discovery"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/FoxSports3.png"
                                    alt="Fox Sports 3"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/ESPN3.png"
                                    alt="ESPN3"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/CNN.png"
                                    alt="CNN en Español"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/usa.png"
                                    alt="usa"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/HISTORY2.png"
                                    alt="History 2"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/UniversalTv.png"
                                    alt="Universal TV"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/A&E.png"
                                    alt="A&E"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/animalPlanet.png"
                                    alt="Animal Planet"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/Aljazeera.png"
                                    alt="Al Jazeera"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/ParamountChannel.png"
                                    alt="Paramount Channel"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/Mtv.png"
                                    alt="MTV"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/MtvHits.png"
                                    alt="MTV Hits"
                                />
                                <img
                                    class="mid-large-logo"
                                    data-src="/assets/img/dummy-img/channels/club-mtv.png"
                                    alt="Club MTV"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/mtv-80s-square.png"
                                    alt="MTV 80s"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/VH1.png"
                                    alt="MTV 00S"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/dreamworks.png"
                                    alt="Dreamworks"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/sony-movies.png"
                                    alt="Sony Movies"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/curiosity.png"
                                    alt="Curiosity"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal" id="canales_izzitvhd" aria-hidden="true">
        <div class="modal__overlay" tabindex="-1" data-micromodal-close>
            <div
                class="modal__container modal__container--channels"
                role="dialog"
                aria-modal="true"
            >
                <button
                    class="modal__close"
                    aria-label="Close modal"
                    data-micromodal-close
                />
                <div class="channel-tabs">
                    <div class="channels-headline addon-tab-controls__holder">
                        <div class="h5 fw-semibold">izzitv con 100 canales</div>
                        <div class="channel-tab-controls">
                            <a
                                href="#izzitvhd_hdchannels"
                                class="channel-tab-control channel-tab-control--active"
                                >Canales HD</a
                            >
                            <a
                                href="#izzitvhd_sdchannels"
                                class="channel-tab-control">Canales SD</a
                            >
                        </div>
                    </div>
                    <div class="channel-tab__content-holder">
                        <div
                            id="izzitvhd_hdchannels"
                            class="channel-tab-content channel-tab-content--active"
                        >
                            <div class="channels-list">
                                <img
                                    class="m-r-5"
                                    data-src="/assets/img/dummy-img/channels/N_Mas-Foro.png"
                                    alt="N+ Foro"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/nueveHD.png"
                                    alt="Nueve HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/canal6Plus.png"
                                    alt="Canal 6 Plus"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/Milenio.png"
                                    alt="Milenio"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/U.png"
                                    alt="Unicable"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/Star-Channel.png"
                                    alt="Star Channel"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/WB_HD.png"
                                    alt="Warner Brothers HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/S_HD.png"
                                    alt="Sony HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/FX.png"
                                    alt="FX HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/Space_HD.png"
                                    alt="Space HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/h&h_HD.png"
                                    alt="Home & Health HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/DiscoveryKids.png"
                                    alt="Discovery Kids"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/bitMe.png"
                                    alt="bitMe HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/DisneyChannelHD.png"
                                    alt="Disney Channel HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/D_HD.png"
                                    alt="Discovery Channel HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/NatGeoHD.png"
                                    alt="National Geographic HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/LasEstrellas.png"
                                    alt="Las Estrellas HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/5HD.png"
                                    alt="Canal Cinco HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/canalOnce.png"
                                    alt="Canal Once"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/canalCatorce.png"
                                    alt="Canal Catorce"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/22.png"
                                    alt="Canal 22"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/CN.png"
                                    alt="Cartoon Network"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/nickelodeon.png"
                                    alt="Nickelodeon"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/E.png"
                                    alt="E!"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/imagen-television.png"
                                    alt="Imagen Televisión"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/CINEMAX.png"
                                    alt="Cinemax"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/History_HD.png"
                                    alt="History HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/TUDN.png"
                                    alt="TUDN HD"
                                />
                                <img
                                    class="large-logo"
                                    data-src="/assets/img/dummy-img/channels/RealMadridTv.png"
                                    alt="Real Madrid TV HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/FoxSports.png"
                                    alt="Fox Sports"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/FoxSports2.png"
                                    alt="Fox Sports 2"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/ESPN.png"
                                    alt="ESPN HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/ESPN2.png"
                                    alt="ESPN2 HD"
                                />
                                <img
                                    class="large-logo"
                                    data-src="/assets/img/dummy-img/channels/Adrenalina.png"
                                    alt="Adrenalina HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/TNT-HD.png"
                                    alt="TNT HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/aMC_HD.png"
                                    alt="AMC HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/UniversalTv.png"
                                    alt="Studio Channel"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/AXN_HD.png"
                                    alt="AXN HD"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/dreamworks.png"
                                    alt="Dreamworks"
                                />
                                <img
                                    class="large-logo"
                                    data-src="/assets/img/dummy-img/channels/PXSports.png"
                                    alt="PX Sports"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/NBA_TV.png"
                                    alt="NBA TV"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/tlnovelas.png"
                                    alt="TLNovelas"
                                />
                                <img
                                    class="m-r-5"
                                    data-src="/assets/img/dummy-img/channels/A&E_HD.png"
                                    alt="A&E HD"
                                />
                                <img
                                    class="m-r-5"
                                    data-src="/assets/img/dummy-img/channels/ID.png"
                                    alt="Investigation Discovery"
                                />
                                <img
                                    class="mid-logo"
                                    data-src="/assets/img/dummy-img/channels/adultswim_HD.png"
                                    alt="AdultSwim HD"
                                />
                                <img
                                    class="m-r-5"
                                    data-src="/assets/img/dummy-img/channels/alt-nfl-hd.png"
                                    alt="NFL HD"
                                />
                            </div>
                        </div>
                        <div
                            id="izzitvhd_sdchannels"
                            class="channel-tab-content"
                        >
                            <div class="channels-list">
                                <img
                                    data-src="/assets/img/dummy-img/channels/LasEstrellas.png"
                                    alt="Las Estrellas"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/cinco.png"
                                    alt="Canal Cinco"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/canalOnce.png"
                                    alt="Canal Once"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/canalCatorce.png"
                                    alt="Canal Catorce"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/22.png"
                                    alt="Canal 22"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/FX.png"
                                    alt="FX"
                                />
                                <img
                                    class="m-r-5"
                                    data-src="/assets/img/dummy-img/channels/N_Mas-Foro.png"
                                    alt="N+ Foro"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/nueve.png"
                                    alt="Nueve"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/home&Health.png"
                                    alt="Discovery Home & Health"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/canal6Plus.png"
                                    alt="Canal 6 Plus"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/tvQuiero.png"
                                    alt="TV Quiero"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/tv-unam.png"
                                    alt="TV Unam"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/canalJudicial.png"
                                    alt="Canal Judicial"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/space.png"
                                    alt="Space"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/imagen-television.png"
                                    alt="Imagen Televisión"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/DistritoComedia.png"
                                    alt="Distrito Comedia"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/Telemundo.png"
                                    alt="Telemundo"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/canalDelCongreso.png"
                                    alt="Canal del Congreso"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/E.png"
                                    alt="E!"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/U.png"
                                    alt="Unicable"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/telehit.png"
                                    alt="Telehit"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/telehitMusica.png"
                                    alt="Telehit Música"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/Bandamax.png"
                                    alt="Bandamax"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/DMX.png"
                                    alt="STINGRAY MUSIC"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/lifeTime.png"
                                    alt="Lifetime"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/UniversalTv.png"
                                    alt="Studio Channel"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/onceNinos.png"
                                    alt="Once Niños"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/CN.png"
                                    alt="Cartoon Network"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/bitMe.png"
                                    alt="bitMe"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/DisneyChannel.png"
                                    alt="Disney Channel"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/DisneyJunior.png"
                                    alt="Disney Junior"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/DiscoveryKids.png"
                                    alt="Discovery Kids"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/Discovery.png"
                                    alt="Discovery Channel"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/NationalGeografic.png"
                                    alt="National Geographic"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/History.png"
                                    alt="History"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/sony-channel.png"
                                    alt="Sony"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/enlace.png"
                                    alt="Enlace"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/EWTN.png"
                                    alt="EWTN"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/Aprende.png"
                                    alt="@prende+"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/22.2.png"
                                    alt="MX Nuestro Cine"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/teleFormula.png"
                                    alt="Telefórmula"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/Milenio.png"
                                    alt="Milenio"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/TUDN.png"
                                    alt="TUDN"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/FoxSports.png"
                                    alt="Fox Sports"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/FoxSports2.png"
                                    alt="Fox Sports 2"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/ESPN.png"
                                    alt="ESPN"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/ESPN2.png"
                                    alt="ESPN2"
                                />
                                <img
                                    class="large-logo"
                                    data-src="/assets/img/dummy-img/channels/RealMadridTv.png"
                                    alt="Real Madrid TV"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/WBtv.png"
                                    alt="Warner Brothers"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/dePelicula.png"
                                    alt="De Película"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/Golden.png"
                                    alt="Golden"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/EDGE.png"
                                    alt="Edge"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/tnt.png"
                                    alt="TNT"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/TNTseries.png"
                                    alt="TNT Series"
                                />
                                <img
                                    class="m-r-5"
                                    data-src="/assets/img/dummy-img/channels/tntNovelas.png"
                                    alt="TNT Novelas"
                                />
                                <img
                                    class="m-r-5"
                                    data-src="/assets/img/dummy-img/channels/aMC.png"
                                    alt="AMC"
                                />
                                <img
                                    class="m-r-5"
                                    data-src="/assets/img/dummy-img/channels/CINEMAX.png"
                                    alt="Cinemax"
                                />
                                <img
                                    class="m-r-5"
                                    data-src="/assets/img/dummy-img/channels/Star-Channel.png"
                                    alt="Star Channel"
                                />
                                <img
                                    data-src="/assets/img/dummy-img/channels/dreamworks.png"
                                    alt="Dreamworks"
                                />
                                <img
                                    class="large-logo"
                                    data-src="/assets/img/dummy-img/channels/Adrenalina.png"
                                    alt="Adrenalina"
                                />
                                <img
                                    class="m-r-5"
                                    data-src="/assets/img/dummy-img/channels/AXN.png"
                                    alt="AXN"
                                />
                                <img
                                    class="m-r-5"
                                    data-src="/assets/img/dummy-img/channels/A&E.png"
                                    alt="A&E"
                                />
                                <img
                                    class="m-r-5"
                                    data-src="/assets/img/dummy-img/channels/tlc.png"
                                    alt="TLC"
                                />
                                <img
                                    class="m-r-5"
                                    data-src="/assets/img/dummy-img/channels/ID.png"
                                    alt="Investigation Discovery"
                                />
                                <img
                                    class="mid-logo"
                                    data-src="/assets/img/dummy-img/channels/adultswim_HD.png"
                                    alt="AdultSwim HD"
                                />
                                <img
                                    class="m-r-5"
                                    data-src="/assets/img/dummy-img/channels/alt-nfl-hd.png"
                                    alt="NFL HD"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
